import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminHeader from "../../common/AdminHeader";
import { Modal, Button, Form, Pagination } from "react-bootstrap";
import Footer from "../../common/Footer";
import { baseUrl, CastePageSize as PageSize } from "../../../Utility/constants";

const EarlyReleaseRemarkMaster = () => {
  const [remarks, setRemarks] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [remark, setRemark] = useState({
    id: 0,
    name: "",
  });

  useEffect(() => {
    fetchRemarks();
  }, []);

  const fetchRemarks = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/EarlyReleaseRemark`);
      setRemarks(response.data);
    } catch (error) {
      toast.error("Failed to fetch details");
    }
  };

  // Calculate total pages
  const totalPages = Math.ceil(remarks.length / PageSize);

  // Calculate current data slice
  const currentData = remarks.slice(
    (currentPage - 1) * PageSize,
    currentPage * PageSize
  );

  // Handle page change
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };


  const handleShowModal = (remark = { id: 0, name: "", }) => {
    setRemark(remark);
    setIsEdit(!!remark.id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setRemark({ id: 0, name: "", });
  };

  const handleSave = async () => {
    try {
      if (remark.id === 0) {
        await axios.post(`${baseUrl}/api/EarlyReleaseRemark`, remark);
        toast.success("Details added successfully");
      } else {
        await axios.put(`${baseUrl}/api/EarlyReleaseRemark/${remark.id}`, remark);
        toast.success("Details updated successfully");
      }
      fetchRemarks();
      handleCloseModal();
    } catch (error) {
      if (error?.response?.data) {
        toast.error(error.response.data);
      }
      else {
        toast.error("Failed to save details");
      }
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete the details?")) {
      try {
        await axios.delete(`${baseUrl}/api/EarlyReleaseRemark/${id}`);
        toast.success("Details deleted successfully");
        fetchRemarks();
      } catch (error) {
        toast.error("Failed to delete details");
      }
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Manage Early Release Remarks </h2>
          <Button variant="primary" onClick={() => handleShowModal()}>
            Add 
          </Button>
        </div>
        <table className="table table-bordered table-striped">
          <thead className="thead-dark">
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentData.map((remark, index) => (
              <tr key={remark.id}>
                <td>{index + 1}</td>
                <td>{remark.name}</td>
                <td>
                  <Button variant="warning" onClick={() => handleShowModal(remark)}>
                    Edit
                  </Button>{" "}
                  <Button variant="danger" onClick={() => handleDelete(remark.id)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination Controls */}
        <Pagination className="justify-content-center">
          <Pagination.First
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          />
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => handlePageChange(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination>

      </div>

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{remark.id === 0 ? "Add" : "Edit"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                value={remark.name}
                onChange={(e) => setRemark({ ...remark, name: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleSave}>
            {isEdit ? "Update" : "Add"}
          </Button>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>

        </Modal.Footer>
      </Modal>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default EarlyReleaseRemarkMaster;
